import { useParams } from 'react-router-dom'
import { sellInvoiceRefundStatusInversed } from '@teinor/erp/types/company/order/sell/sellInvoiceRefund'
import SellInvoiceRefundFinishedStep from './Steps/SellInvoiceRefundFinishedStep'
import { TableComponentProps } from '../../../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { InputTableURLsTable } from '../../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import useOrderScreenLogic from '../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/useOrderScreenLogic'


interface SingleSellInvoiceRefundProps extends TableComponentProps { }

const SingleSellInvoiceRefund: React.FC<SingleSellInvoiceRefundProps> = ({ userPermissions }) => {
    const params = useParams<{ id: string }>()
    const OrderId = params.id

    const inputTableURLs: InputTableURLsTable = {
        createData: ['', {}],
        getData: ['/api/app/order/sell/sellInvoiceRefund/getSellInvoiceRefundComplete', { id: OrderId }],
        updateData: '',
        delete: '',
        updateHeaderData: '/api/app/order/sell/sellInvoiceRefund/updateSellInvoiceRefund',
        getSubProducts: ['', ['CustomerId']],
        updateOrderLines: '',
        printTags: ''
    }
    const { completeData, setCompleteData, getCompleteData, tableConfiguration, setTableConfiguration, headerChanges } = useOrderScreenLogic({ inputTableURLs, userPermissions: 'sell.refundInvoice' })
    const status = parseInt(completeData?.header.status)
    if (status === sellInvoiceRefundStatusInversed['accepted']) {
        return <SellInvoiceRefundFinishedStep {...{ completeData, setCompleteData, getCompleteData, inputTableURLs, userPermissions, tableConfiguration, setTableConfiguration, headerChanges }} />
    }
    return null
}

export default SingleSellInvoiceRefund